module.exports = __webpack_public_path__ + "static/media/LSMInversionLoop.1a340524.gif";